module.exports = __webpack_public_path__ + "static/media/reel-left-arrow.d64fb343.svg";